import HttpFactory from '~/repository/factory';

class SitemapRepository extends HttpFactory {

    async index(): Promise<string> {
        return await this.getRaw('/sitemap');
    }

    async chunk(page: string): Promise<string> {
        return await this.getRaw(`sitemap/${page}`);
    }
}

export default SitemapRepository;